// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCuSCgOoSQOfEpr5tTDUxpBZTBUsHrCWyg",
  authDomain: "intosoundhealing-15120.firebaseapp.com",
  projectId: "intosoundhealing-15120",
  storageBucket: "intosoundhealing-15120.firebasestorage.app",
  messagingSenderId: "849753600089",
  appId: "1:849753600089:web:f0b30cfc08134d5b78c148",
  measurementId: "G-H78V0VY5W4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);
export const auth = getAuth(app);